import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "portsdebt_cookies_consent_v1";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const accept = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-6 lg:left-auto lg:right-6 lg:bottom-6 z-[60] bg-white border border-slate-200 shadow-2xl rounded-sm p-5 lg:p-6 max-w-lg ml-auto"
    >
      <div className="text-xs uppercase tracking-[0.22em] text-sky font-semibold">
        Aviso de cookies
      </div>
      <p className="mt-3 text-sm text-ink-muted leading-relaxed">
        Esta web utiliza cookies técnicas necesarias para su correcto funcionamiento. No utilizamos
        cookies de seguimiento ni publicidad. Puede consultar nuestra{" "}
        <Link
          to="/politica-de-privacidad"
          className="text-navy underline hover:text-sky"
        >
          política de privacidad
        </Link>
        .
      </p>
      <div className="mt-5 flex flex-col sm:flex-row gap-2 sm:gap-3">
        <button
          onClick={() => accept("accepted")}
          data-testid="cookie-accept"
          className="bg-navy text-white hover:bg-navy-700 px-5 py-2.5 rounded-md text-sm font-medium transition-colors"
        >
          Aceptar
        </button>
        <button
          onClick={() => accept("rejected")}
          data-testid="cookie-reject"
          className="border border-slate-300 text-ink hover:bg-slate-50 px-5 py-2.5 rounded-md text-sm font-medium transition-colors"
        >
          Rechazar
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
